import React from 'react';
import BackgroundRemover from './components/BackgroundRemover';

const BackgroundRemoverTest = () => {
  return (
    <div>
      <BackgroundRemover />
    </div>
  );
};

export default BackgroundRemoverTest;

